﻿/*
 * Globalize Culture hu-HU
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("hu-HU", "default", {
    name: "hu-HU",
    englishName: "Hungarian (Hungary)",
    nativeName: "magyar (Magyarország)",
    language: "hu",
    numberFormat: {
      ",": " ",
      ".": ",",
      NaN: "nem szám",
      negativeInfinity: "negatív végtelen",
      positiveInfinity: "végtelen",
      percent: {
        ",": " ",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": " ",
        ".": ",",
        symbol: "Ft"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "vasárnap",
            "hétfő",
            "kedd",
            "szerda",
            "csütörtök",
            "péntek",
            "szombat"
          ],
          namesAbbr: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
          namesShort: ["V", "H", "K", "Sze", "Cs", "P", "Szo"]
        },
        months: {
          names: [
            "január",
            "február",
            "március",
            "április",
            "május",
            "június",
            "július",
            "augusztus",
            "szeptember",
            "október",
            "november",
            "december",
            ""
          ],
          namesAbbr: [
            "jan.",
            "febr.",
            "márc.",
            "ápr.",
            "máj.",
            "jún.",
            "júl.",
            "aug.",
            "szept.",
            "okt.",
            "nov.",
            "dec.",
            ""
          ]
        },
        AM: ["de.", "de.", "DE."],
        PM: ["du.", "du.", "DU."],
        eras: [{ name: "i.sz.", start: null, offset: 0 }],
        patterns: {
          d: "yyyy.MM.dd.",
          D: "yyyy. MMMM d.",
          t: "H:mm",
          T: "H:mm:ss",
          f: "yyyy. MMMM d. H:mm",
          F: "yyyy. MMMM d. H:mm:ss",
          M: "MMMM d.",
          Y: "yyyy. MMMM"
        }
      }
    },
    messages: {
      AdditionalHelp: "További súgó",
      AddNewTab: "Új fül felvétele",
      Alerts: "Figyelmeztetések",
      ApplyFilter: "Szűrő alkalmazása",
      Approve: "Jóváhagyás",
      Attachments: "Csatolmányok",
      Back: "Vissza",
      Basic: "Alapvető",
      Between: "Között",
      Book: "Könyv",
      Cancel: "Mégsem",
      Checked: "Bejelölve",
      ClearFilter: "Szűrő törlése",
      Close: "Bezárás",
      CloseCancelChanges: "Bezárás és módosítások elvetése",
      CloseSaveChanges: "Bezárás és módosítások mentése",
      CloseTab: "Fül bezárása",
      ColumnPersonalization: "Oszlop testreszabása",
      Comments: "Megjegyzések",
      Confirmation: "Megerősítés",
      Contains: "Tartalmazza",
      CreateTab: "Új fül létrehozása",
      Cut: "Kivágás",
      Delete: "Törlés",
      DiscardUndo: "Elvetés/Visszavonás",
      DisplayDropDownList: "Legördülő lista megjelenítése",
      Displaying: "Megjelenítve: ",
      DocWord: "Dokumentum",
      DoesNotContain: "Nem tartalmazza",
      DoesNotEndWith: "Nem vége",
      DoesNotEqual: "Nem egyenlő",
      DoesNotStartWith: "Nem kezdete",
      Download: "Letöltés",
      Duplicate: "Duplikátum",
      Edit: "Szerkesztés",
      EitherSelectedorNotSelected: "Kiválasztott vagy nem kiválasztott",
      Email: "E-mail",
      EndsWith: "Vége",
      EqualsStr: "Egyenlő",
      ExpandCollapse: "Kibontás/Összecsukás",
      ExportFailed: "Exportálás sikertelen",
      ExportToExcel: "Exportálás Excelbe",
      FileInUse: "A megadott fájl használatban van",
      FileInUseDetail:
        "Zárja be az alkalmazást, amely használja, vagy adjon meg másik fájlnevet.",
      Filter: "Szűrő",
      FilterMenu: "Szűrő menü",
      FilterOptions: "Szűrő beállítások",
      FilterWithinResults: "Találatok szűrése",
      First: "Első",
      FirstView: "Első nézet",
      Folder: "Mappa",
      ForgotPassword: "Elfelejtette a jelszavát?",
      Forward: "Továbbítás",
      GetMoreRows: "További sorok behívása",
      GreaterThan: "Nagyobb, mint",
      GreaterThanOrEquals: "Nagyobb, vagy egyenlő",
      GridSettings: "Rácsbeállítások",
      GroupSelection: "Csoport kiválasztása",
      Help: "Súgó",
      HideColumn: "Oszlop elrejtése",
      IsEmpty: "Üres",
      IsNotEmpty: "Nem üres",
      Last: "Utolsó",
      LastView: "Utolsó nézet",
      LaunchActivate: "Elindítás/Aktiválás",
      LessThan: "Kisebb, mint",
      LessThanOrEquals: "Kisebb, vagy egyenlő",
      Links: "Hivatkozások",
      ListTabs: "Minden fül listázása",
      LoadingItem: "Elem betöltése ",
      Maintenance: "Karbantartás",
      Menu: "Menü",
      New: "Új",
      Next: "Következő",
      NextView: "Következő nézet",
      No: "Nem",
      NotChecked: "Nincs bejelölve",
      Notes: "Jegyzetek",
      NotSelected: "Nem kiválasztott",
      Of: " / ",
      Ok: "OK",
      Open: "Megnyitás",
      Password: "Jelszó",
      Paste: "Beszúrás",
      Phone: "Telefon",
      PleaseWait: "Kérjük, várjon.",
      Previous: "Előző",
      PreviousView: "Előző nézet",
      Print: "Nyomtatás",
      Queries: "Lekérdezések",
      Redo: "Mégis",
      Refresh: "Frissítés",
      Reject: "Elutasítás",
      RememberMe: "Emlékezzen rám ezen a számítógépen",
      Reports: "Jelentések",
      Reset: "Visszaállítás",
      Review: "Áttekintés",
      RunFilter: "Szűrő futtatása",
      RunJob: "Feladat futtatása",
      Save: "Mentés",
      SaveBeforeClosing: "Mentés és bezárás",
      SavedFilters: "Mentett szűrők",
      SaveSubmit: "Mentés/Beadás Mentés/Elküldés",
      ScreenDesign: "Képernyőterv",
      Search: "Keresés",
      SelectContents: "Tartalom kiválasztása",
      SelectDate: "Dátum kiválasztása",
      SelectDeselect: "Mindet kiválasztja / Minden kiválasztás megszüntetése",
      Selected: "Kiválasztva: ",
      ServerName: "Kiszolgáló neve",
      Settings: "Beállítások",
      ShowFilterRow: "Szűrősor mutatása",
      SignIn: "Bejelentkezés",
      SortAscending: "Rendezés növekvő sorrendben",
      SortDescending: "Rendezés csökkenő sorrendben",
      Spreadsheet: "Táblázatkezelő",
      StartsWith: "Kezdete",
      StatusIndicator: "Állapotjelző",
      Tasks: "Feladatok",
      Today: "Ma",
      Translate: "Fordítás",
      UserID: "Felhasználói azonosító",
      Utilities: "Segédprogramok",
      Yes: "Igen",
      Page: "Oldal",
      Rows: "Sorok",
      ShowingAll: "Mindet mutatja",
      SessionNavigation: "Munkamenet navigáció",
      ListAllMenuItems: "Minden menüelem listázása",
      NoRecordsFound: "Nem található rekord",
      SearchTree: "Fa keresése",
      Clear: "Törlés",
      DrillDown: "Lefúrás",
      Required: "Ez egy kötelező mező",
      Available: "Elérhető:",
      Add: "Hozzáadás",
      MoveDown: "Mozgatás lefelé",
      MoveUp: "Mozgatás felfelé",
      Remove: "Eltávolítás",
      LastYear: "Elmúlt év",
      NextMonth: "Következő hónap",
      NextWeek: "Következő hét",
      NextYear: "Következő év",
      OneMonthAgo: "Egy hónappal ezelőtt",
      OneWeekAgo: "Egy héttel ezelőtt",
      SixMonthsAgo: "Hat hónappal ezelőtt",
      Time: "Idő",
      CannotBeSelected: "Ezt a sort nem lehet kiválasztani.",
      ResetToDefault: "Visszaállítás alapértelmezett elrendezésre",
      CloseOtherTabs: "Többi fül bezárása",
      EmailValidation: "Adjon meg érvényes e-mail címet",
      UrlValidation: "Adjon meg érvényes URL-t",
      EndofResults: "Eredmények vége",
      More: "Tovább...",
      RecordsPerPage: "Rekord oldalanként",
      Maximize: "Maximalizálja",
      Minimize: "Kisebb"
    }
  });
})(this);
